import styled from 'styled-components'
import Threshold from 'constants/threshold'
import Colors from 'constants/colors'
import { ReactSVG } from 'react-svg'

export const ArtistsPageStyled = styled.main`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  margin-bottom: 50px;

  & .wrapper .name-slash {
    color: ${Colors.orange};
  }

  & .tabs {
    width: 100%;
    margin: 0 auto;

    & .tab-list {
      width: 90%;
      display: flex;
      justify-content: space-between;
      margin: 0 auto 40px;
      max-width: 360px;

      & .tab {
        display: flex;
        align-items: center;
        cursor: pointer;
        font-size: 20px;

        &:focus {
          outline: none;
        }

        &:not(:last-child) {
          margin-right: 20px;
        }

        & span {
          margin-left: 37px;
        }

        &_selected:before {
          content: '';
          display: block;
          width: 17px;
          height: 30px;
          background-image: url('/svgs/slash.svg');
          margin-right: 20px;
          background-position: center center;
        }

        &_selected span {
          margin-left: 0;
          font-weight: bold;
        }
      }
    }
  }

  & .active {
    color: ${Colors.orange};
  }

  & .pagination {
    display: flex;
    justify-content: center;

    & li:not(:last-child) {
      margin-right: 10px;
    }

    & li {
      width: 32px;
      height: 32px;
      cursor: pointer;
      box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.15);
      border-radius: 2px;

      & a {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        font-weight: 500;
        font-size: 14px;
        user-select: none;
      }

      & a:focus {
        border: none;
        outline: none;
      }
    }
  }

  @media (min-width: ${Threshold.tablet}) {
    & .tabs .tab-list {
      margin-bottom: 60px;
      max-width: 600px;

      & .tab {
        font-size: 35px;
      }
    }
  }
`

export const Slash = styled.span`
  color: ${Colors.orange};
`
export const DataWrapper = styled.div`
  margin: 0 auto;
  max-width: max-content;
`

export const LoadingIcon = styled(ReactSVG)`
  width: 120px;
  height: 110px;
  margin-left: 5px;
  animation: animate 2.5s linear infinite;

  @keyframes animate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
  svg {
    fill: ${Colors.orange}
    width: 100%;
    height: 100%;
  }
`
